import { Box, Divider, Stack } from '@mui/material';
import { editor } from 'monaco-editor';
import DrivebaseControl from '../../Drawers/Drivebase/DrivebaseControl';
import TreeSitterInputBindingStatus from '../../Drawers/Controller/TreeSitterInputBindingStatus';
import { ActionMappingControlList } from '../../Drawers/Controller/ActionMappingControlList';
import { usePythonTreeSitterReady } from '../../../hooks/editor/usePythonTreeSitterReady';
import { INPUT_BINDING_DEVICE } from '../../../utils/inputBindings';

const { DRIVEBASE } = INPUT_BINDING_DEVICE;

interface DrivebaseConfigurationTabProps {
  editor?: editor.IStandaloneCodeEditor;
}

const DrivebaseConfigurationTab: React.FC<DrivebaseConfigurationTabProps> = ({ editor }) => {
  const treeSitterStatus = usePythonTreeSitterReady();

  return (
    <Box sx={{ p: 2 }}>
      <Stack direction="column" spacing={2}>
        <TreeSitterInputBindingStatus status={treeSitterStatus} />
        <Box
          width="100%"
          alignSelf="center"
          textAlign="center"
          sx={{
            // Make the drivebase controller SVG responsive up to 300px, then fixed
            '& svg': { width: '100%', maxWidth: 300, height: 'auto' },
          }}
        >
          <DrivebaseControl editor={editor} mappingsReady={treeSitterStatus.mappingsReady} />
        </Box>
        <Divider />
        <ActionMappingControlList device={DRIVEBASE} editor={editor} mappingsReady={treeSitterStatus.mappingsReady} />
      </Stack>
    </Box>
  );
};

export default DrivebaseConfigurationTab;
